// JavaScript Document
$(function () {
/*
======================
BODY FADE IN
======================
*/

    setTimeout(function () {
        $("body").removeClass("fade-out");
    }, 320);

    setTimeout(function () {
        $("body").addClass("loaded");
        $("#page-loader").fadeOut(900);
        $(".page-wrap").removeClass("fade-out");
    }, 1200);

/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

    if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
        $("html").addClass("safari");
    }

/*
======================
FANCYBOX (LAZY LOAD)
======================
Only needed once someone actually opens a lightbox/video popup — load it on
the first click of a [data-fancybox] trigger instead of on every page view.
*/

    var fancyboxLoaded = false;
    function loadFancybox(onReady) {
        if (fancyboxLoaded) {
            onReady();
            return;
        }
        fancyboxLoaded = true;

        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = fancybox_params.css;
        document.head.appendChild(link);

        var script = document.createElement('script');
        script.src = fancybox_params.js;
        script.onload = onReady;
        document.head.appendChild(script);
    }

    $(document).on('click', '[data-fancybox]', function (e) {
        if (fancyboxLoaded) {
            // Fancybox's own delegated click handler (bound once its script
            // has loaded) takes over from here on.
            return;
        }
        e.preventDefault();
        var el = this;
        loadFancybox(function () {
            // Fancybox binds its own [data-fancybox] click handler as soon as
            // it loads — replay the click now that it's listening, so this
            // first click actually opens the lightbox instead of doing
            // nothing.
            $(el).trigger('click');
        });
    });

    /*
================================
SCROLL ANIMATIONS (GSAP SCROLLTRIGGER)
================================
*/

    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
        gsap.registerPlugin(ScrollTrigger);

        // Direction/target classes applied alongside class="gsap-fade" (e.g. class="gsap-fade fadeInUp").
        var gsapFadeAnimations = {
            fadeInUp:          { duration: 1.8, from: { opacity: 0, yPercent: 12 }, to: { opacity: 1, yPercent: 0 } },
            fadeInLeft:        { duration: 2.5, from: { opacity: 0, xPercent: -8 }, to: { opacity: 1, xPercent: 0 } },
            fadeInRight:       { duration: 1.8, from: { opacity: 0, xPercent: 8 }, to: { opacity: 1, xPercent: 0 } },
            "fade-in-onload":  { duration: 1.8, from: { opacity: 0 }, to: { opacity: 0.05 } },
            fadeIn:            { duration: 1.8, from: { opacity: 0 }, to: { opacity: 1 } },
        };

        // Triangles animate faster than everything else, but wait longer before starting
        // (so they still land after the content they accent has settled in).
        var TRIANGLE_DURATION_SCALE = 0.5;
        var TRIANGLE_EXTRA_DELAY    = 0.4;

        // Elements sharing an animation type + trigger offset are batched together so
        // GSAP's own `stagger` sequences them automatically as they scroll into view —
        // no more manually computing per-item delays (e.g. "$i / 12") in PHP.
        var gsapFadeBatches = {};

        // Elements waiting on a specific other element (data-gsap-after) rather than a
        // scroll offset of their own.
        var gsapFadeDeferred = [];

        // Batch keys are scoped per-section so stagger only ever applies within one
        // component instance. Without this, any two unrelated elements elsewhere on the
        // page that happen to share the same animation/offset/duration (very common with
        // the shared defaults) get bundled into the same GSAP stagger sequence — which can
        // silently delay an element by several seconds if enough unrelated things pile in.
        var gsapFadeSectionIndex = 0;
        var gsapFadeSectionIds = typeof WeakMap !== "undefined" ? new WeakMap() : null;

        function getGsapFadeSectionKey(el) {
            var section = el.closest("section") || document.body;
            if (!gsapFadeSectionIds) return "";
            if (!gsapFadeSectionIds.has(section)) {
                gsapFadeSectionIds.set(section, "sec" + (gsapFadeSectionIndex++));
            }
            return gsapFadeSectionIds.get(section);
        }

        function resolveGsapFadeConfig(el) {
            var $el = $(el);
            var animName = "fadeIn";
            for (var name in gsapFadeAnimations) {
                if ($el.hasClass(name)) {
                    animName = name;
                    break;
                }
            }

            var isTriangle = $el.hasClass("triangle");
            var offset = parseFloat($el.attr("data-gsap-offset")) || 0;
            var customDuration = parseFloat($el.attr("data-gsap-duration")) || 0;
            var baseConfig = gsapFadeAnimations[animName];
            var duration = customDuration || (isTriangle ? baseConfig.duration * TRIANGLE_DURATION_SCALE : baseConfig.duration);
            var config = Object.assign({}, baseConfig, { duration: duration });
            var key = getGsapFadeSectionKey(el) + "|" + (isTriangle ? "triangle-" : "") + animName + "|" + offset + "|" + duration;

            return { config: config, offset: offset, isTriangle: isTriangle, key: key };
        }

        function queueGsapFadeElement(el) {
            if (el.dataset.gsapFadeInitialized) return;
            el.dataset.gsapFadeInitialized = "true";

            var resolved = resolveGsapFadeConfig(el);

            // Take over from the (now inert) CSS keyframe entirely so nothing fights GSAP.
            gsap.set(el, Object.assign({ visibility: "visible", animation: "none" }, resolved.config.from));

            var afterSelector = el.getAttribute("data-gsap-after");
            if (afterSelector) {
                gsapFadeDeferred.push({ el: el, config: resolved.config, afterSelector: afterSelector });
                return;
            }

            var key = resolved.key;
            if (!gsapFadeBatches[key]) {
                gsapFadeBatches[key] = { config: resolved.config, offset: resolved.offset, extraDelay: resolved.isTriangle ? TRIANGLE_EXTRA_DELAY : 0, elements: [] };
            }
            gsapFadeBatches[key].elements.push(el);
        }

        function findGsapFadeAfterTarget(item) {
            // Scope the lookup to the nearest section so repeated instances of the same
            // layout on one page don't cross-wire onto each other's target element.
            var scope = item.el.closest("section") || document;
            return scope.querySelector(item.afterSelector);
        }

        // A single ScrollTrigger.batch() onEnter can stagger several elements as ONE shared
        // tween (e.g. 3 sibling cards entering together) — tween.eventCallback("onComplete", fn)
        // REPLACES any previously attached handler rather than adding to it, so multiple
        // data-gsap-after dependents on that same shared tween would otherwise clobber each
        // other. Queue callbacks ourselves and fire them all from one onComplete handler.
        function onGsapFadeTweenComplete(tween, fn) {
            if (!tween.gsapFadeCallbacks) {
                tween.gsapFadeCallbacks = [];
                tween.eventCallback("onComplete", function () {
                    tween.gsapFadeCallbacks.forEach(function (cb, i) { cb(i * 0.15); });
                });
            }
            tween.gsapFadeCallbacks.push(fn);
        }

        // Re-checked every time any tween is created, since a deferred item's target could
        // be animated by any batch, not just the one that just fired.
        function runDeferredGsapFadeElements() {
            gsapFadeDeferred = gsapFadeDeferred.filter(function (item) {
                var targetEl = findGsapFadeAfterTarget(item);
                if (!targetEl || !targetEl.gsapFadeTween) return true; // keep waiting

                onGsapFadeTweenComplete(targetEl.gsapFadeTween, function (staggerDelay) {
                    gsap.to(item.el, Object.assign({ duration: item.config.duration, delay: staggerDelay, ease: "power1.out" }, item.config.to));
                });
                return false; // handed off, remove from the deferred queue
            });
        }

        function flushGsapFadeBatches() {
            Object.keys(gsapFadeBatches).forEach(function (key) {
                var batch = gsapFadeBatches[key];
                var config = batch.config;

                ScrollTrigger.batch(batch.elements, {
                    start: "top bottom-=" + batch.offset,
                    once: true,
                    onEnter: function (elements) {
                        // One tween PER element (not one shared multi-target tween) so each
                        // element's own onComplete fires when IT finishes, not when the last
                        // (most-delayed) sibling in the stagger finishes — that mismatch was
                        // making data-gsap-after dependents wait for the whole group.
                        elements.forEach(function (el, i) {
                            // A fixed data-gsap-delay (deliberate, non-computed) still applies as a
                            // base delay on top of the manual stagger, plus any group-level extra
                            // delay (e.g. triangles waiting for their block to settle in first).
                            var ownDelay = batch.extraDelay + (parseFloat(el.getAttribute("data-gsap-delay")) || 0) + i * 0.15;
                            var tween = gsap.to(el, Object.assign({
                                duration: config.duration,
                                delay: ownDelay,
                                ease: "power1.out",
                            }, config.to));

                            // Tag the element with the tween actually driving it, so
                            // data-gsap-after can target this SPECIFIC element rather than
                            // "whichever element shares the same animation/offset/duration".
                            el.gsapFadeTween = tween;
                        });
                        runDeferredGsapFadeElements();
                    },
                });
            });
            gsapFadeBatches = {};
        }

        function initAllGsapFadeElements(context) {
            $(context || document)
                .find(".gsap-fade")
                .addBack(".gsap-fade")
                .each(function () {
                    queueGsapFadeElement(this);
                });
            flushGsapFadeBatches();
            runDeferredGsapFadeElements();
        }

        initAllGsapFadeElements();

        // Auto-init .gsap-fade elements added later (e.g. the news/case-study/event/video AJAX load-more grids).
        // Debounced: one AJAX render can insert many nodes in one go, and
        // initAllGsapFadeElements() already re-scans + flushes GSAP batches
        // each time it runs — without this, a burst of mutations would
        // trigger that full pass once per added node instead of once total.
        // data-gsap-fade-initialized already guards against re-processing
        // the same element, so a single full-document rescan per burst is
        // both cheap and safe.
        if (window.MutationObserver) {
            var gsapFadeMutationTimeout = null;
            var gsapFadeObserver = new MutationObserver(function () {
                clearTimeout(gsapFadeMutationTimeout);
                gsapFadeMutationTimeout = setTimeout(function () {
                    initAllGsapFadeElements();
                }, 50);
            });
            gsapFadeObserver.observe(document.body, { childList: true, subtree: true });
        }

        // Images/fonts loading after this point can still shift section heights
        // (e.g. a background image sizing its parent), leaving already-created
        // ScrollTrigger positions stale for anything below/beside it.
        $(window).on("load", function () {
            ScrollTrigger.refresh();
        });
    }

    /*
=========================
OBJECT FIT
=========================
*/

    $(function () {
        objectFitImages("img.object-fit");
    });

    /*
=====================
TEL LINKS
=====================
*/

    //Disable on desktop (non touch)...
    $(".no-touch a.tel").on("click", function (e) {
        e.preventDefault();
    });

    /*
=====================
TABLE WRAPPER
=====================
*/

    if (!$('body').hasClass('woocommerce-page')) {
        $("table").wrap('<div class="table-wrap"></div>');
    }

    /*
======================
IFRAME WRAPPER
======================
*/

    $(".page-section iframe").wrap('<div class="iframe-wrap"></div>');

    /*
===============================
FIXED HEADER
===============================
*/

    //add header class
    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 1) {
            $("#masthead").addClass("scrolled");
        } else {
            $("#masthead").removeClass("scrolled");
        }
    });

    //check page position and add class if not at the top of page on load
    var pagePostion = $(window).scrollTop();

    if (pagePostion > 1) {
        $("#masthead").addClass("scrolled");
    } else {
        $("#masthead").removeClass("scrolled");
    }

    /*
======================
HAMBURGER MENU
======================
*/

    //open menu
    $(".menu-toggle").on("click", function () {
        $("body").toggleClass("mobile-navigation--open");
        $(this).toggleClass("active");
        $(".mobile-navigation").toggleClass("active");
    });

    $("#main-navigation .menu-item-has-children").append('<div class="child-chevron"><i class="fa-sharp fa-solid fa-chevron-right"></i></div>');

    $("#mobile-navigation .menu-item-has-children").append('<div class="menu-expand"><i class="fa-sharp fa-solid fa-chevron-up"></i></div>');

    $(".menu-expand").on("click", function () {
        $(this).toggleClass("active");
        $(this).parent("li").toggleClass("active");
        $(this).parent("li").toggleClass("sub-menu-open");
        $(this).parent("li").find("> ul.sub-menu").slideToggle(600);
    });

    //hover class
    $("#main-navigation ul li")
        .on("mouseenter", function () {
            $(this).addClass("active-hover");
        })
        .on("mouseleave", function () {
            $(this).removeClass("active-hover");
        });

    // Flip dropdown to right-align if it would overflow the viewport edge
    $(".main-navigation > ul > li").on("mouseenter", function () {
        var $subWrap = $(this).children(".sub-wrap");
        if (!$subWrap.length) return;
        $subWrap.removeClass("align-right");
        var rect = $subWrap[0].getBoundingClientRect();
        if (rect.right > $(window).width()) {
            $subWrap.addClass("align-right");
        }
    });

    $(".main-menu .close").on("click", function () {
        $(".hamburger").removeClass("active");
        $(".main-menu").removeClass("active");
    });

    /*
================================
MENU AIM
================================
*/

    /*var $menu = $(".main-menu .desktop-menu ul");

    $menu.menuAim({
        activate: activateSubmenu,
        deactivate: deactivateSubmenu,
    });

    function activateSubmenu(row) {
        var $row = $(row),
            $submenu = $row.children("ul");

        $row.children("a").addClass("hover");
        $submenu.css({display: "block"});
    }

    function deactivateSubmenu(row) {
        var $row = $(row),
            $submenu = $row.children("ul");

        $row.find("a").removeClass("hover");
        $submenu.css("display", "none");
    }

    $(document).click(function () {
        $(".main-menu .desktop-menu ul li a.hover").removeClass("hover");
    });*/

    /*
=======================================
RESPONSIVE DATA TABLES
=======================================
*/

    var tables = document.querySelectorAll(".page-section .table-wrap table");
    for (var a = 0; a < tables.length; a++) {
        var headertext = [];
        var headers = tables[a].querySelectorAll("thead td"),
            tablebody = tables[a].querySelector("tbody");

        for (var i = 0; i < headers.length; i++) {
            var current = headers[i];
            headertext.push(current.textContent.replace(/\r?\n|\r/, ""));
        }
        for (var i = 0, row; (row = tablebody.rows[i]); i++) {
            for (var j = 0, col; (col = row.cells[j]); j++) {
                col.setAttribute("data-th", headertext[j]);
            }
        }
    }

    /*
======================================
SMOOTH SCROLL
======================================
*/

    // SMOOTH SCROLLING FROM ANOTHER PAGE TO CORRECT ID
    //START AT TOP OF PAGE AND SCROLL DOWN ALWAYS
    if (window.location.hash) {
        setTimeout(function () {
            $("html, body").scrollTop(0).show();
            $("html, body").animate(
                {
                    scrollTop: $(window.location.hash).offset().top - 0,
                },
                1000
            );
        }, 0);
    } else {
        $("html, body").show();
    }

    //SMOOTH SCROLLING
    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('[data-fancybox]')
        .click(function (event) {
            // On-page links
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $("html, body").animate(
                        {
                            scrollTop: target.offset().top - 110,
                        },
                        1000,
                        function () {
                            // Callback after animation
                            // Must change focus!
                        }
                    );
                }
            }
        });

    /*
=========================
ACCORDION
=========================
*/

    $(".accordion-item .toggle-header").on("click", function () {
        $(this).parent(".accordion-item").toggleClass("active");
        $(this).next(".toggle-content").slideToggle("slow");
    });

    /*
=========================
UP ARROW
=========================
*/

    $(".up").on("click", function (event) {
        event.preventDefault();
        $("body,html").animate({scrollTop: 0}, 1000);
    });

    /*
==========================
BUTTONS
==========================
*/

    if ($("p .button").length > 0) {
        $("p").each(function () {
            if ($(this).find(".button").length === 2) {
                $(this).addClass("two-buttons");
            }
        });
    }

    /*
==========================
SLIDERS
==========================
*/

    //Banner Slider
    var swiper1 = new Swiper(".banner-slider .swiper", {
        /*navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },*/
        autoplay: true,
        loop: true,
        effect: "fade",
        slidesPerView: 1,
        spaceBetween: 50,
        centeredSlides: true,
        centeredSlidesBounds: true,
        navigation: false,
        pagination: {
            el: ".banner-slider .swiper-pagination",
        },
    });

    //Small Image slider
    var swiper2 = new Swiper(".swiper-6-slides", {
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
            nextEl: ".small-image-slider .swiper-button-next",
            prevEl: ".small-image-slider .swiper-button-prev",
        },
        pagination: {
            el: ".small-image-slider .swiper-pag",
        },
        breakpoints: {
            900: {
                slidesPerView: 4,
                spaceBetween: 50,
            },
            1200: {
                slidesPerView: 5,
                spaceBetween: 70,
            },
            1600: {
                slidesPerView: 6,
                spaceBetween: 100,
            },
        },
    });

    //Large Image Slider
    var swiper3 = new Swiper(".mySwiper3", {
        spaceBetween: 20,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".large-image-slider .swiper-button-next",
            prevEl: ".large-image-slider .swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pag-2",
        },
        breakpoints: {
            900: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
        },
    });

    var swiper4 = new Swiper(".mySwiper4", {
        slidesPerView: 1,
        // thumbs: {
        //     swiper: swiper3,
        // },
    });

    swiper4.on("slideChange", () => {
        swiper3.slideTo(swiper4.activeIndex);
    });

    //reviews carousel
    var swiper2 = new Swiper(".reviews-carousel", {
        slidesPerView: 1,
        spaceBetween: 50,
        centeredSlides: false,
        centeredSlidesBounds: false,
        loop: true,
        navigation: {
            nextEl: ".reviews-carousel .swiper-button-next",
            prevEl: ".reviews-carousel .swiper-button-prev",
        },
        pagination: {
            el: ".reviews-carousel .swiper-pagination",
        },
        breakpoints: {
            680: {
                slidesPerView: 1,
                spaceBetween: 40,
            },
            850: {
                slidesPerView: 2,
                spaceBetween: 80,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 80,
            },
        },
    });

    //Featured Team Members
    var swiperTeam = new Swiper(".team-members-swiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: false,
        pagination: {
            el: ".team-members-pagination",
            clickable: true,
        },
        breakpoints: {
            650: {
                slidesPerView: 2,
            },
            820: {
                slidesPerView: 3,
            },
        },
    });

    //Single Page Related Content
    var swiper5 = new Swiper(".related__swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: ".reviews .swiper-button-next",
            prevEl: ".reviews .swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pag-4",
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1600: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
    });

    // Swipers can change a section's height after ScrollTrigger has already
    // measured its trigger positions (slide sizing, pagination dots, etc.) —
    // without a refresh, a gsap-fade element sitting below/beside a swiper
    // can end up scroll-triggered against stale coordinates and never
    // actually complete its animation once you scroll to it.
    if (typeof ScrollTrigger !== "undefined") {
        ScrollTrigger.refresh();
    }

    /*
============================
TRIANGLE BACKGROUNDS
============================
*/

$('.image-and-content').each(function() {

    var $section = $(this);
    var $tri1 = $section.find('.tri-1');
    var $tri2 = $section.find('.tri-2');

    if (!$tri1.length || !$tri2.length) return;

    // Use your Tailwind CSS variables (or replace with hex values if needed)
    var styles = getComputedStyle(document.documentElement);

    var colors = [
        styles.getPropertyValue('--color-themeBlue').trim(),
        styles.getPropertyValue('--color-sunset').trim(),
        styles.getPropertyValue('--color-mustard').trim(),
        styles.getPropertyValue('--color-violet').trim(),
        styles.getPropertyValue('--color-titanWhite').trim()
    ];

    // Shuffle colors
    colors.sort(() => Math.random() - 0.5);

    // Apply two different colours
    $tri1.css('background-color', colors[0]);
    $tri2.css('background-color', colors[1]);

});

    /*
==========================
RECAPTCHA FADEOUT
==========================
*/

    $(window).on("scroll", function () {
        var documentHeight = $(document).height();
        var windowHeight = $(window).height();
        var scrollPosition = $(window).scrollTop();

        if (documentHeight - (windowHeight + scrollPosition) < 100) {
            $(".grecaptcha-badge").addClass("fade");
        } else {
            $(".grecaptcha-badge").removeClass("fade");
        }
    });

    /*
==========================
AJAX
==========================
*/

    /*
    ==========================
    NEWS FILTER + LOAD MORE
    ==========================
    */

    if ($('#news-grid').length) {

        var currentPage     = 1;
        var currentCategory = '';
        var currentYear     = '';
        var newsLoading     = false;

        function loadNews(page, append) {
            if (newsLoading) return;
            newsLoading = true;

            var $grid    = $('#news-grid');
            var $section = $('#news-loadmore-section');
            var $btn     = $('#news-loadmore');

            if (!append) {
                $grid.css('opacity', '0.5');
            }
            $btn.text('Loading...');

            $.ajax({
                url: loadmore_params.ajaxurl,
                type: 'POST',
                data: {
                    action:   'news_filter',
                    page:     page,
                    category: currentCategory,
                    year:     currentYear,
                    exclude:  news_params.featured_id
                },
                success: function(response) {
                    if (response.success) {
                        if (append) {
                            $grid.append(response.data.html);
                        } else {
                            $grid.html(response.data.html);
                            $grid.css('opacity', '1');
                        }
                        currentPage = page;
                        if (page < response.data.max_page) {
                            $section.show().removeClass('hidden');
                            $btn.text('Load more');
                        } else {
                            $section.hide();
                        }
                    } else {
                        if (!append) {
                            $grid.html('<p class="col-span-3 no-posts-found">No posts found.</p>');
                            $grid.css('opacity', '1');
                        }
                        $section.hide();
                    }
                    newsLoading = false;
                }
            });
        }

        $('#news-filter-category, #news-filter-year').on('change', function() {
            currentCategory = $('#news-filter-category').val();
            currentYear     = $('#news-filter-year').val();
            currentPage     = 1;
            loadNews(1, false);
        });

        $('#news-loadmore').on('click', function() {
            loadNews(currentPage + 1, true);
        });

    }

    /*
    ==========================
    VIDEO LOAD MORE
    ==========================
    */

    if ($('#video-grid').length) {

        var videoPage    = 1;
        var videoLoading = false;

        function loadVideos(page) {
            if (videoLoading) return;
            videoLoading = true;

            var $grid    = $('#video-grid');
            var $section = $('#video-loadmore-section');
            var $btn     = $('#video-loadmore');

            $btn.text('Loading...');

            $.ajax({
                url: loadmore_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'video_loadmore',
                    page:   page
                },
                success: function(response) {
                    if (response.success) {
                        $grid.append(response.data.html);
                        videoPage = page;
                        if (page < response.data.max_page) {
                            $section.show().removeClass('hidden');
                            $btn.text('Load more');
                        } else {
                            $section.hide();
                        }
                    } else {
                        $section.hide();
                    }
                    videoLoading = false;
                }
            });
        }

        $('#video-loadmore').on('click', function() {
            loadVideos(videoPage + 1);
        });

    }

    /*
    ==========================
    CASE STUDY FILTER + LOAD MORE
    ==========================
    */

    if ($('#case-study-grid').length) {

        var csPage     = 1;
        var csCategory = '';
        var csYear     = '';
        var csLoading  = false;

        function loadCaseStudies(page, append) {
            if (csLoading) return;
            csLoading = true;

            var $grid    = $('#case-study-grid');
            var $section = $('.load-more-posts');
            var $btn     = $('#case-study-load-more');

            if (!append) {
                $grid.css('opacity', '0.5');
            }
            $btn.text('Loading...');

            $.ajax({
                url: loadmore_params.ajaxurl,
                type: 'POST',
                data: {
                    action:   'case_study_filter',
                    page:     page,
                    category: csCategory,
                    year:     csYear,
                    exclude:  (typeof case_study_params !== 'undefined') ? case_study_params.featured_id : 0,
                },
                success: function(response) {
                    if (response.success) {
                        if (append) {
                            $grid.append(response.data.html);
                        } else {
                            $grid.html(response.data.html);
                            $grid.css('opacity', '1');
                        }
                        csPage = page;
                        if (page < response.data.max_page) {
                            $section.show().removeClass('hidden');
                            $btn.text('Load More');
                        } else {
                            $section.hide();
                        }
                    } else {
                        if (!append) {
                            $grid.html('<p class="col-span-3 no-posts-found">No case studies found.</p>');
                            $grid.css('opacity', '1');
                        }
                        $section.hide();
                    }
                    csLoading = false;
                }
            });
        }

        $('#case-study-filter-category, #case-study-filter-year').on('change', function() {
            csCategory = $('#case-study-filter-category').val();
            csYear     = $('#case-study-filter-year').val();
            csPage     = 1;
            loadCaseStudies(1, false);
        });

        $('#case-study-load-more').on('click', function() {
            loadCaseStudies(csPage + 1, true);
        });

    }

    /*
    ==========================
    EVENT FILTER + LOAD MORE
    ==========================
    */

    if ($('#event-grid').length) {

        var eventPage     = 1;
        var eventCategory = '';
        var eventYear     = '';
        var eventLoading  = false;

        function loadEvents(page, append) {
            if (eventLoading) return;
            eventLoading = true;

            var $grid    = $('#event-grid');
            var $section = $('#event-loadmore-section');
            var $btn     = $('#event-loadmore');

            if (!append) {
                $grid.css('opacity', '0.5');
            }
            $btn.text('Loading...');

            $.ajax({
                url: loadmore_params.ajaxurl,
                type: 'POST',
                data: {
                    action:   'event_filter',
                    page:     page,
                    category: eventCategory,
                    year:     eventYear,
                    exclude:  (typeof event_params !== 'undefined') ? event_params.featured_id : 0
                },
                success: function(response) {
                    if (response.success) {
                        if (append) {
                            $grid.append(response.data.html);
                        } else {
                            $grid.html(response.data.html);
                            $grid.css('opacity', '1');
                        }
                        eventPage = page;
                        if (page < response.data.max_page) {
                            $section.show().removeClass('hidden');
                            $btn.text('Load more');
                        } else {
                            $section.hide();
                        }
                    } else {
                        if (!append) {
                            $grid.html('<p class="col-span-3 no-posts-found">No events found.</p>');
                            $grid.css('opacity', '1');
                        }
                        $section.hide();
                    }
                    eventLoading = false;
                }
            });
        }

        $('#event-filter-category, #event-filter-year').on('change', function() {
            eventCategory = $('#event-filter-category').val();
            eventYear     = $('#event-filter-year').val();
            eventPage     = 1;
            loadEvents(1, false);
        });

        $('#event-loadmore').on('click', function() {
            loadEvents(eventPage + 1, true);
        });

    }

    /*
    ==========================
    CART QUANTITY FIX
    ==========================
    */

    /*if ($('.woocommerce-cart-form').length) {
        $('tr.woocommerce-cart-form__cart-item').each(function() {
            var $row   = $(this);
            var $qtyTd = $row.find('td.product-quantity');

            // Already has a visible number input — nothing to do.
            var $existingNumber = $qtyTd.find('input[type="number"]');
            if ($existingNumber.length && $existingNumber.is(':visible')) return;

            // Try to get cart key from existing qty input (hidden or otherwise).
            var cartKey = null;
            var existingQty = 1;
            var $anyQtyInput = $row.find('input[name*="[qty]"]');
            if ($anyQtyInput.length) {
                var nameMatch = $anyQtyInput.attr('name').match(/cart\[([a-f0-9]+)\]\[qty\]/);
                if (nameMatch) {
                    cartKey = nameMatch[1];
                    existingQty = parseInt($anyQtyInput.val(), 10) || 1;
                }
            }

            // Fall back to extracting the key from the remove link URL.
            if (!cartKey) {
                var removeHref = $row.find('.product-remove a').attr('href') || '';
                var keyMatch   = removeHref.match(/[?&]remove_item=([a-f0-9]+)/);
                if (!keyMatch) return;
                cartKey = keyMatch[1];
            }

            $qtyTd.html(
                '<div class="quantity">' +
                '<input type="number" class="input-text qty text" ' +
                'name="cart[' + cartKey + '][qty]" ' +
                'value="' + existingQty + '" min="1" step="1" />' +
                '</div>'
            );
        });
    }*/

    /*
    ==========================
    SHARED: ADD-TO-CART TOAST
    Used by both the participants modal and the module tray below.
    ==========================
    */

    function showAddToCartToast(message) {
        var $toast = $('#add-to-cart-toast');
        if (!$toast.length) {
            $toast = $('<div id="add-to-cart-toast"></div>').appendTo('body');
        }
        $toast.text(message).addClass('visible');
        setTimeout(function() { $toast.removeClass('visible'); }, 5000);
    }

    // Small "Added" tooltip above the button itself. Appended to <body> and
    // positioned via the button's page offset, rather than nested inside it,
    // since .button has overflow:hidden (for its diagonal corner effect) and
    // would clip anything positioned outside its own box.
    function showAddedTooltip($btn, message) {
        var $tooltip = $('<div class="add-module-tooltip">' + (message || 'Module Selected') + '</div>').appendTo('body');
        var offset = $btn.offset();

        $tooltip.css({
            top:  offset.top - $tooltip.outerHeight() - 10,
            left: offset.left + ($btn.outerWidth() / 2) - ($tooltip.outerWidth() / 2)
        });

        requestAnimationFrame(function() { $tooltip.addClass('visible'); });
        setTimeout(function() {
            $tooltip.removeClass('visible');
            setTimeout(function() { $tooltip.remove(); }, 200);
        }, 1500);
    }

    // Native WooCommerce ajax_add_to_cart buttons (e.g. the Product Blocks
    // layout) fire this event on success — reuse the same tooltip instead of
    // WC's default "View basket" link appearing next to the button.
    $(document.body).on('added_to_cart', function(e, fragments, cart_hash, $button) {
        if ($button && $button.length) {
            showAddedTooltip($button, 'Added to basket');
        }
    });

    /*
    ==========================
    PARTICIPANTS MODAL
    Single-item popup — adds one product straight to the basket immediately
    (e.g. featured development programmes). Not part of the module tray below.
    ==========================
    */

    if ($('#participants-modal').length) {

        var $modal      = $('#participants-modal');
        var $overlay    = $modal.find('.modal-overlay');
        var $error      = $('#modal-error');
        var activeProductId = null;

        function updateModalConfirmLabel(courseFormat) {
            var $btn = $('#modal-confirm');
            if (courseFormat === 'Face to Face') {
                $btn.html('<i class="fa-solid fa-envelope"></i> Get in touch');
            } else {
                $btn.html('<i class="fa-solid fa-basket-shopping"></i> Add to basket');
            }
        }

        function openModal(productId, productName) {
            activeProductId = productId;
            $('#modal-product-name').text(productName);
            $('#course-format-select').val('Online');
            $('#participants-select').val('');
            updateModalConfirmLabel('Online');
            $error.addClass('hidden');
            $modal.removeClass('hidden');
        }

        function closeModal() {
            $modal.addClass('hidden');
            activeProductId = null;
        }

        $(document).on('click', '.add-to-basket-btn', function() {
            openModal($(this).data('product-id'), $(this).data('product-name'));
        });

        $overlay.add('#modal-cancel, .modal-close').on('click', closeModal);

        $('#course-format-select').on('change', function() {
            updateModalConfirmLabel($(this).val());
        });

        $('#modal-confirm').on('click', function() {
            var courseFormat  = $('#course-format-select').val();
            var participants  = $('#participants-select').val();
            // Participants is optional for Face to Face (just an enquiry), but
            // still required for Online, since it's booked straight to the basket.
            if (!courseFormat || (courseFormat !== 'Face to Face' && !participants)) {
                $error.removeClass('hidden');
                return;
            }
            $error.addClass('hidden');

            // Face to Face isn't taken via the basket — hand off to the same
            // enquiry form the module tray uses, instead of adding to cart.
            if (courseFormat === 'Face to Face') {
                var productName = $('#modal-product-name').text();
                closeModal();
                if (typeof openGetInTouchModal === 'function') {
                    openGetInTouchModal([{ product_name: productName, participants: participants }]);
                }
                return;
            }

            var $btn = $(this);
            $btn.prop('disabled', true).html('<i class="fa-solid fa-basket-shopping"></i> Adding...');

            $.ajax({
                url: loadmore_params.ajaxurl,
                type: 'POST',
                data: {
                    action:        'add_to_cart_with_participants',
                    product_id:    activeProductId,
                    participants:  participants,
                    course_format: courseFormat,
                    nonce:         shop_params.singleNonce,
                },
                success: function(response) {
                    if (response.success) {
                        closeModal();

                        // Already viewing the cart page — reload so the newly
                        // added item actually shows up in the rendered table.
                        // Checking the body class rather than .woocommerce-cart-form,
                        // since the cart page may render via the WooCommerce Cart
                        // block instead of the classic shortcode markup.
                        if ($('body').hasClass('woocommerce-cart')) {
                            window.location.reload();
                            return;
                        }

                        var count = response.data.cart_count;
                        var $badge = $('.cart-count');
                        $badge.text(count).removeClass('hidden');
                        showAddToCartToast('Added to basket!');
                    } else {
                        $error.text(response.data.message || 'Could not add to basket.').removeClass('hidden');
                    }
                    $btn.prop('disabled', false).html('<i class="fa-solid fa-basket-shopping"></i> Add to basket');
                },
                error: function() {
                    $error.text('Something went wrong. Please try again.').removeClass('hidden');
                    $btn.prop('disabled', false).html('<i class="fa-solid fa-basket-shopping"></i> Add to basket');
                }
            });
        });

        // Close on Escape key
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape') closeModal();
        });

    }

    /*
    ==========================
    GET IN TOUCH MODAL
    Shown instead of the basket when the module tray's course format is set
    to Face to Face.
    ==========================
    */

    if ($('#get-in-touch-modal').length) {
        var $getInTouchModal = $('#get-in-touch-modal');

        var openGetInTouchModal = function(items) {
            var $list = $('#get-in-touch-modules').empty();
            var summaryLines = [];

            items.forEach(function(item) {
                var line = item.product_name;
                if (item.participants) {
                    line += ' (' + item.participants + ' participants)';
                }
                summaryLines.push(line);
            });

            if (items.length) {
                var $ul = $('<ul>', { style: 'list-style: disc; padding-left: 20px;' });
                summaryLines.forEach(function(line) {
                    $('<li>').text(line).appendTo($ul);
                });
                $list.append($ul);
            }

            // Gravity Forms id 3, hidden field id 7 — populated so the enquiry
            // email includes which courses/participant counts were selected.
            $('#input_3_7').val(summaryLines.join(', ')).trigger('change');

            $getInTouchModal.removeClass('hidden');
        };

        var closeGetInTouchModal = function() {
            $getInTouchModal.addClass('hidden');
        };

        $getInTouchModal.find('.modal-overlay, .modal-close').on('click', closeGetInTouchModal);

        $(document).on('keydown', function(e) {
            if (e.key === 'Escape') closeGetInTouchModal();
        });
    }

    /*
    ==========================
    MODULE TRAY
    Fixed bottom bar — "Add Module" (shop archive, single product) appends a
    bare product to a persistent (localStorage-backed) tray. Course format
    applies to the whole tray, chosen once above the module list: Online adds
    everything to the basket in one bulk action; Face to Face opens the get in
    touch enquiry form instead, since those bookings aren't taken via the basket.
    ==========================
    */

    if ($('#module-tray').length) {

        var MODULE_TRAY_STORAGE_KEY = 'courseModuleTray';

        function getModuleTrayState() {
            try {
                var stored = JSON.parse(localStorage.getItem(MODULE_TRAY_STORAGE_KEY));
                if (stored && Array.isArray(stored.items)) {
                    // Self-heal older saved trays with a blank course_format
                    // (from before Online became the default) rather than only
                    // defaulting on a brand-new, never-saved tray.
                    stored.course_format = stored.course_format || 'Online';
                    return stored;
                }
            } catch (e) {}
            return { course_format: 'Online', items: [] };
        }

        function saveModuleTrayState(state) {
            localStorage.setItem(MODULE_TRAY_STORAGE_KEY, JSON.stringify(state));
        }

        function buildModuleTrayRow(item) {
            var $row = $(document.getElementById('module-tray-item-template').content.cloneNode(true)).find('.module-tray-item');
            $row.attr('data-tray-id', item.id);
            $row.find('.tray-item-name').text(item.product_name);
            $row.find('.tray-item-price').text(item.product_price ? ' - ' + item.product_price : '');
            $row.find('.tray-participants').val(item.participants);
            return $row;
        }

        function updateSubmitButtonLabel(courseFormat) {
            var $btn = $('#module-tray-submit');
            if (courseFormat === 'Face to Face') {
                $btn.html('<i class="fa-solid fa-envelope"></i> Get in touch');
            } else {
                $btn.html('<i class="fa-solid fa-basket-shopping"></i> Add all to basket');
            }
        }

        // Same tiers as get_multi_buy_discount_tiers() in functions/inc/woocommerce.php —
        // every module in the tray qualifies, since Training Program products (which
        // don't) are never added here, only via the separate single-item popup.
        function getMultiBuyDiscountPercent(itemCount) {
            var tiers = [[12, 15], [8, 10], [4, 7], [3, 5], [2, 3]];
            for (var i = 0; i < tiers.length; i++) {
                if (itemCount >= tiers[i][0]) return tiers[i][1];
            }
            return 0;
        }

        // Online/Face to Face are priced differently per item, and that choice is
        // shared by the whole tray — defaults to the Online price as an estimate
        // until a format is explicitly chosen, rather than hiding the total entirely.
        function updateModuleTrayTotal() {
            var state      = getModuleTrayState();
            var $discount  = $('#module-tray-discount');
            var $vat       = $('#module-tray-vat');
            var $total     = $('#module-tray-total');
            var $barSummary = $('#module-tray-bar-summary');

            if (!state.items.length || state.course_format === 'Face to Face') {
                $discount.addClass('hidden');
                $vat.addClass('hidden');
                $total.addClass('hidden');
                $barSummary.addClass('hidden');
                return;
            }

            // Participants is informational (headcount) only — price doesn't scale
            // with group size, so the subtotal is just the sum of each course's price.
            var priceKey = state.course_format === 'Face to Face' ? 'price_face_to_face' : 'price_online';
            var subtotal = state.items.reduce(function(sum, item) {
                return sum + (parseFloat(item[priceKey]) || 0);
            }, 0);

            var symbol        = (typeof shop_params !== 'undefined' && shop_params.currencySymbol) ? shop_params.currencySymbol : '';
            var vatRate         = (typeof shop_params !== 'undefined' && shop_params.vatRate) ? parseFloat(shop_params.vatRate) : 0;
            var discountPercent = getMultiBuyDiscountPercent(state.items.length);
            var discountAmount  = subtotal * (discountPercent / 100);
            var netTotal         = subtotal - discountAmount;
            var vatAmount        = netTotal * (vatRate / 100);
            var total            = netTotal + vatAmount;

            if (discountPercent) {
                $discount.text('Multi-buy discount (' + discountPercent + '%): -' + symbol + discountAmount.toFixed(2)).removeClass('hidden');
            } else {
                $discount.addClass('hidden');
            }

            if (vatRate) {
                $vat.text('VAT (' + vatRate + '%): ' + symbol + vatAmount.toFixed(2)).removeClass('hidden');
            } else {
                $vat.addClass('hidden');
            }

            var label = state.course_format ? 'Total: ' : 'Total (Online): ';
            $total.text(label + symbol + total.toFixed(2) + ' (+VAT)').removeClass('hidden');

            // Only show the running total/discount next to the "modules
            // added" count once a multi-buy discount actually kicks in —
            // otherwise the collapsed bar just stays as the plain count.
            if (discountPercent) {
                $barSummary.text('Total: ' + symbol + total.toFixed(2) + ' (' + discountPercent + '% off)').removeClass('hidden');
            } else {
                $barSummary.addClass('hidden');
            }
        }

        // Buttons already disabled server-side for being in the real basket
        // (see disableAddModuleButton) have had data-product-id stripped off,
        // so this selector naturally leaves those alone — only buttons still
        // eligible to be added are ever toggled here.
        function syncAddModuleButtons(state) {
            var trayProductIds = state.items.map(function(item) { return String(item.product_id); });

            $('.add-module-btn[data-product-id]').each(function() {
                var $btn = $(this);
                var inTray = trayProductIds.indexOf(String($btn.data('product-id'))) !== -1;

                $btn.prop('disabled', inTray);
                if (inTray) {
                    $btn.attr('title', 'This module is already in your tray')
                        .html('<i class="fa-solid fa-check"></i> Selected');
                } else {
                    $btn.removeAttr('title')
                        .html('<i class="fa-solid fa-plus"></i> Add Module');
                }
            });
        }

        function renderModuleTray() {
            var state  = getModuleTrayState();
            var $tray  = $('#module-tray');
            var $items = $('#module-tray-items');

            $('#tray-course-format').val(state.course_format);
            updateSubmitButtonLabel(state.course_format);

            $items.empty();
            state.items.forEach(function(item) {
                $items.append(buildModuleTrayRow(item));
            });

            $('#module-tray-count').text(state.items.length);
            $('#module-tray-count-plural').text(state.items.length === 1 ? '' : 's');

            updateModuleTrayTotal();
            syncAddModuleButtons(state);

            if (state.items.length > 0) {
                $tray.removeClass('hidden');
            } else {
                $tray.addClass('hidden');
                $('#module-tray-panel').addClass('hidden');
                $('#module-tray-chevron').removeClass('active');
            }
        }

        function addModuleToTray(productId, productName, productPrice, priceOnline, priceFaceToFace, $btn) {
            var state = getModuleTrayState();

            var alreadyInTray = state.items.some(function(item) {
                return String(item.product_id) === String(productId);
            });
            if (alreadyInTray) {
                showAddToCartToast(productName + ' is already in your tray');
                $('#module-tray-panel').removeClass('hidden');
                $('#module-tray-chevron').addClass('active');
                return;
            }

            // Only pop the tray open automatically the first time it goes
            // from empty to having something in it — just enough to show
            // the user where their selection lives, without reopening it
            // every time they add another module on top.
            var wasEmpty = state.items.length === 0;

            state.items.push({
                id: Date.now() + '-' + Math.random().toString(36).slice(2),
                product_id: productId,
                product_name: productName,
                product_price: productPrice || '',
                price_online: priceOnline || 0,
                price_face_to_face: priceFaceToFace || 0,
                participants: ''
            });
            saveModuleTrayState(state);
            renderModuleTray();
            if ($btn && $btn.length) {
                showAddedTooltip($btn);
            }
            if (wasEmpty) {
                $('#module-tray-panel').removeClass('hidden');
                $('#module-tray-chevron').addClass('active');
            }
        }

        // Swaps any matching "Add Module" button on the current page (shop
        // archive, single product) to its disabled "Already in Basket" state,
        // so a module just added doesn't stay clickable until the next full
        // page load — the AJAX add doesn't trigger a reload here, only on
        // the cart page itself.
        function disableAddModuleButton(productId) {
            $('.add-module-btn[data-product-id="' + productId + '"]')
                .prop('disabled', true)
                .removeAttr('data-product-id data-product-name data-product-price data-price-online data-price-face-to-face')
                .attr('title', 'This module is already in your basket')
                .html('<i class="fa-solid fa-check"></i> Already in Basket');
        }

        function removeModuleFromTray(id) {
            var state = getModuleTrayState();
            state.items = state.items.filter(function(item) { return item.id !== id; });
            saveModuleTrayState(state);
            renderModuleTray();
        }

        function updateModuleParticipants(id, value) {
            var state = getModuleTrayState();
            state.items.forEach(function(item) {
                if (item.id === id) item.participants = value;
            });
            saveModuleTrayState(state);
            updateModuleTrayTotal();
        }

        renderModuleTray();

        $(document).on('click', '.add-module-btn', function() {
            addModuleToTray(
                $(this).data('product-id'),
                $(this).data('product-name'),
                $(this).data('product-price'),
                $(this).data('price-online'),
                $(this).data('price-face-to-face'),
                $(this)
            );
        });

        $('#module-tray-toggle').on('click', function() {
            $('#module-tray-panel').toggleClass('hidden');
            $('#module-tray-chevron').toggleClass('active');
        });

        // #module-tray-toggle is a plain div (not a <button>) now that it
        // also contains the "View Selection" button, so Enter/Space no
        // longer toggle it natively — wire that back up for keyboard users.
        $('#module-tray-toggle').on('keydown', function(e) {
            if (e.target.id !== 'module-tray-toggle') return;
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).trigger('click');
            }
        });

        // Minimise the tray when clicking anywhere outside it. Stopping
        // propagation for clicks inside the tray (rather than checking
        // e.target.closest() from the document handler) means this can't be
        // fooled by a click that itself mutates/removes DOM — e.g. removing a
        // module rebuilds #module-tray-items, which would otherwise leave
        // e.target detached by the time this handler runs.
        $('#module-tray').on('click', function(e) {
            e.stopPropagation();
        });

        $(document).on('click', function(e) {
            // .add-module-btn has its own document-level click handler
            // (above) that can open the tray for the first module added —
            // this handler runs on the same click right after it, and would
            // otherwise immediately close what that one just opened.
            if ($(e.target).closest('.add-module-btn').length) return;
            $('#module-tray-panel').addClass('hidden');
            $('#module-tray-chevron').removeClass('active');
        });

        $('#tray-course-format').on('change', function() {
            var state = getModuleTrayState();
            state.course_format = $(this).val();
            saveModuleTrayState(state);
            updateSubmitButtonLabel(state.course_format);
            updateModuleTrayTotal();
            $('#module-tray-error').addClass('hidden');
        });

        $(document).on('change', '.tray-participants', function() {
            updateModuleParticipants($(this).closest('.module-tray-item').data('tray-id'), $(this).val());
        });

        $('#module-tray').on('click', '.tray-remove', function() {
            removeModuleFromTray($(this).closest('.module-tray-item').data('tray-id'));
        });

        $('#module-tray-clear').on('click', function() {
            saveModuleTrayState({ course_format: '', items: [] });
            renderModuleTray();
        });

        $('#module-tray-submit').on('click', function() {
            var state  = getModuleTrayState();
            var $error = $('#module-tray-error');

            if (!state.items.length) {
                return;
            }

            if (!state.course_format) {
                $error.text('Please select a course format for this basket.').removeClass('hidden');
                return;
            }

            if (state.course_format === 'Face to Face') {
                $error.addClass('hidden');
                $('#module-tray-panel').addClass('hidden');
                $('#module-tray-chevron').removeClass('active');
                openGetInTouchModal(state.items);
                return;
            }

            $error.addClass('hidden');

            var modules = state.items.map(function(item) {
                return {
                    product_id: item.product_id,
                    participants: item.participants,
                    course_format: state.course_format
                };
            });

            var $btn = $(this);
            $btn.prop('disabled', true).html('<i class="fa-solid fa-basket-shopping"></i> Adding...');

            $.ajax({
                url: loadmore_params.ajaxurl,
                type: 'POST',
                data: {
                    action:  'add_modules_to_cart',
                    modules: JSON.stringify(modules),
                    nonce:   shop_params.nonce
                },
                success: function(response) {
                    if (response.success) {
                        modules.forEach(function(module) {
                            disableAddModuleButton(module.product_id);
                        });
                        saveModuleTrayState({ course_format: '', items: [] });

                        // Already viewing the cart page — a reload is the
                        // simplest way to show the newly added items, since
                        // the rendered table has no idea anything changed.
                        // Checking the body class rather than .woocommerce-cart-form,
                        // since the cart page may render via the WooCommerce Cart
                        // block instead of the classic shortcode markup.
                        if ($('body').hasClass('woocommerce-cart')) {
                            window.location.reload();
                            return;
                        }

                        renderModuleTray();
                        var count = response.data.cart_count;
                        $('.cart-count').text(count).removeClass('hidden');
                        showAddToCartToast('Added to basket!');
                    } else {
                        $error.text(response.data.message || 'Could not add to basket.').removeClass('hidden');
                    }
                    updateSubmitButtonLabel(getModuleTrayState().course_format);
                    $btn.prop('disabled', false);
                },
                error: function() {
                    $error.text('Something went wrong. Please try again.').removeClass('hidden');
                    updateSubmitButtonLabel(getModuleTrayState().course_format);
                    $btn.prop('disabled', false);
                }
            });
        });

    }

    /*
    ===============================
    PRODUCT FILTER + LOAD MORE
    ===============================
    */

    if ($('#products-grid').length) {

        var currentProductPage    = 1;
        var currentProductCat     = (typeof shop_params !== 'undefined') ? shop_params.current_cat : 0;
        var currentProductOrderby = $('#products-orderby').val() || 'menu_order';
        var productLoading        = false;

        // Arriving with a category already selected (e.g. "?shop_category=compliance"
        // from another page) — jump straight to the filters/grid instead of leaving
        // the visitor to scroll past the banner to notice anything's filtered.
        if (currentProductCat) {
            var $filters = $('.product-filters');
            if ($filters.length) {
                $('html, body').animate({ scrollTop: $filters.offset().top - 80}, 500);
            }
        }

        function loadProducts(page, append) {
            if (productLoading) return;
            productLoading = true;

            var $grid    = $('#products-grid');
            var $section = $('#products-loadmore-section');
            var $btn     = $('#products-loadmore');

            if (!append) {
                $grid.css('opacity', '0.5');
            }
            if ($btn.length) $btn.text('Loading...');

            $.ajax({
                url: loadmore_params.ajaxurl,
                type: 'POST',
                data: {
                    action:   'product_filter',
                    page:     page,
                    category: currentProductCat,
                    orderby:  currentProductOrderby,
                },
                success: function(response) {
                    if (response.success) {
                        if (append) {
                            $grid.append(response.data.html);
                        } else {
                            $grid.html(response.data.html);
                            $grid.css('opacity', '1');
                        }
                        currentProductPage = page;
                        if (page < response.data.max_page) {
                            if ($section.length) $section.show();
                            if ($btn.length) $btn.text('Load more');
                        } else {
                            if ($section.length) $section.hide();
                        }
                    } else {
                        if (!append) {
                            $grid.html('<p class="col-span-3 no-posts-found">No products found.</p>');
                            $grid.css('opacity', '1');
                        }
                        if ($section.length) $section.hide();
                    }
                    productLoading = false;
                }
            });
        }

        $('.product-filter-btn').on('click', function() {
            $('.product-filter-btn').removeClass('active');
            $(this).addClass('active');
            currentProductCat  = parseInt($(this).data('cat')) || 0;
            currentProductPage = 1;
            loadProducts(1, false);
        });

        $('#products-loadmore').on('click', function() {
            loadProducts(currentProductPage + 1, true);
        });

        $('#products-orderby').on('change', function() {
            currentProductOrderby = $(this).val();
            currentProductPage    = 1;
            loadProducts(1, false);
        });

    }

    //LOAD MORE POSTS
    $(".news-posts .posts-container").on("click", ".load-more", function (e) {
        e.preventDefault();

        var loaded = $("input.post-count").val();

        $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: "POST",
            data: {
                action: "load_more_posts",
                already_loaded: loaded,
            },
            beforeSend: function () {
                $(".news-posts .posts-container .load-more-posts").fadeTo(600, 0, function () {
                    $(".news-posts .posts-container .load-more-posts").html('<div class="load"></div>');
                });
                $(".news-posts .posts-container .load-more-posts").delay(300).fadeTo(400, 1);
            },
            success: function (data) {
                $(".news-posts .posts-container .load-more-posts")
                    .delay(1000)
                    .fadeOut(700, function () {
                        $(".news-posts .posts-container .load-more-posts").remove();
                        $(".news-posts .posts-container").append(data);
                    });
            },
        });
    });
}); //end document.ready
